import posthog from "posthog-js";
import { POSTHOG_API_KEY, POSTHOG_HOST_API } from "../config";
import { usePostHogStore } from "../store/usePostHogStore";
export const useInitPostHog = ({ loaded, ...initConfig } = {}) => {
    const { setIsReady } = usePostHogStore();
    const isAbleToInitPostHog = useIsAbleToInitPostHog();
    if (isAbleToInitPostHog) {
        posthog.init(POSTHOG_API_KEY, {
            api_host: POSTHOG_HOST_API,
            loaded: (_posthog) => {
                setIsReady(true);
                if (loaded)
                    loaded(_posthog);
            },
            ...initConfig,
        });
        return posthog;
    }
};
const useIsAbleToInitPostHog = () => {
    const { isReady: isPostHogReady } = usePostHogStore();
    const hasWindow = typeof window !== "undefined";
    return hasWindow && !isPostHogReady && !!POSTHOG_API_KEY;
};
